import { EditorContent } from "@tiptap/react";
import { ComposerLinkInput } from "./ComposerLinkInput";
import { EmojiSuggestionList } from "./EmojiSuggestionList";
import { MentionSuggestionList } from "./MentionSuggestionList";
import { ChatComposer } from "./useChatComposerEditor";

type ChatComposerEditorProps = {
  composer: ChatComposer;
};

export const ChatComposerEditor = ({ composer }: ChatComposerEditorProps) => {
  const { editor, mentionPopup, emojiPopup, isLinkInputOpen, closeLinkInput } =
    composer;

  return (
    <div className="t-relative t-flex t-flex-col t-gap-2">
      {mentionPopup && <MentionSuggestionList popup={mentionPopup} />}
      {emojiPopup && <EmojiSuggestionList popup={emojiPopup} />}
      {isLinkInputOpen && (
        <ComposerLinkInput editor={editor} onClose={closeLinkInput} />
      )}
      <EditorContent
        editor={editor}
        className="t-max-h-48 t-min-h-6 t-overflow-y-auto"
      />
    </div>
  );
};
